import { useCallback, useReducer } from 'react';
import { useLocalStorage } from 'react-use';
import { actionTypes } from 'reducer/actionType';

export const LOCAL_STORAGE_EXU_KEY = 'populate_existing_user';

export type StateTypeExistingPatient = {
  name: string;
  title?: string;
  value: string[] | string | Object;
  image?: string[];
};

export type ActiveTypeExistingPatient = {
  type: string;
  name: string;
  value: string[] | string;
  image?: string;
};

export const initialState: StateTypeExistingPatient[] = [
  {
    name: actionTypes.PAGE_ONE,
    title: '',
    value: [],
  },
  {
    name: actionTypes.PAGE_TWO,
    title: '',
    value: [],
  },
  {
    name: actionTypes.PAGE_THREE,
    title: '',
    value: [],
  },
];

const reducer = (state: any, action: ActiveTypeExistingPatient) => {
  switch (action.type) {
    case actionTypes.PAGE_ONE:
      return state.map((data: StateTypeExistingPatient) => {
        if (data.name === action.type) {
          return { ...data, title: action.name, value: action.value };
        }
        return data;
      });
    case actionTypes.PAGE_TWO:
      return state.map((data: StateTypeExistingPatient) => {
        if (data.name === action.type) {
          return { ...data, title: action.name, value: action.value };
        } return data;
      });
    case actionTypes.PAGE_THREE:
      return state.map((data: StateTypeExistingPatient) => {
        if (data.name === action.type) {
          return { ...data, title: action.name, value: action.value };
        } return data;
      });
    default:
      return state;
  }
};

export const usePersistExistingPatientReducer: any = () => {
  const [savedState, saveState, remove] = useLocalStorage(
    LOCAL_STORAGE_EXU_KEY,
    initialState,
  );

  const reducerLocalStorage: any = useCallback(
    // give `reducerLocalStorage` the same TS API
    // as the underlying `reducer` function
    (
      state: StateTypeExistingPatient[],
      action: ActiveTypeExistingPatient,
    ): StateTypeExistingPatient[] => {
      const newState = reducer(state, action);

      saveState(newState);

      return newState;
    },
    [saveState],
  );

  return useReducer(reducerLocalStorage, savedState);
};

export const useClearLocalStorage = () => useLocalStorage(LOCAL_STORAGE_EXU_KEY);
